'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import enviro from 'enviro';
import I18n from 'I18n';
import ExternalScript from './ExternalScript'; // Based off code from marketing-orchestration-ui

const SURVICATE_SCRIPT_SRC = 'https://survey.survicate.com/workspaces/f9c3c9f21edc7399fda4dca9f64fb53c/web_surveys.js';

const Survicate = () => {
  const isCorrectEnvironment = enviro.isProd() || enviro.isQa() && enviro.deployed();
  const isCorrectLanguage = I18n.lang === 'en';

  if (isCorrectEnvironment && isCorrectLanguage) {
    return /*#__PURE__*/_jsx(ExternalScript, {
      id: "survicate",
      src: SURVICATE_SCRIPT_SRC
    });
  }

  return null;
};

export default Survicate;